import { connect } from "react-redux";

import { post } from "../../../../../../../actions/general";
import { editTask } from "../../../../../../../store/plan/actions";

import NonBars from "./NonBars";

export default connect(null, { editTask, post })(NonBars);
